import React, { useState } from 'react';

import Tabs from '../layout/Tabs';
import ReadCompleteProcessingQrcodePanel from '../panels/ReadCompleteProcessingQrcodePanel';
import ProcessingList from '../lists/ProcessingList';
import ProcessingContainer from '../../containers/Processing';

const Root = (() => {

  const processingContainer = ProcessingContainer.useContainer();

  const [isLoading, setIsLoading] = useState(false);

  const handleQueryChange = async (date: Date, page: number, pageSize: number) => {
    setIsLoading(true);

    await processingContainer.load({
      offset: pageSize * page,
      limit: pageSize,
      createdDate: date,
    });

    setIsLoading(false);
  }

  return (
    <Tabs tabInfos={[
      {
        label: 'QR Code',
        panel: <ReadCompleteProcessingQrcodePanel />,
      },
      {
        label: 'List',
        panel: <ProcessingList onQueryChange={handleQueryChange} isLoading={isLoading} showToolbar={true} showDateTimePicker={true} showPaging={true} />,
      }
    ]} />
  )
}) as React.FC;

export default (() => {
  return (
    <ProcessingContainer.Provider>
      <Root />
    </ProcessingContainer.Provider>
  )
}) as React.FC;
